import { Component, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialogResultData,
  AbstractDialog,
  AbstractDialogData,
} from '@next/core-lib/dialog';

export interface ImportSetupDialogModel extends AbstractDialogData {
  deliveriesFrom: Date;
  deliveriesUntil: Date;
}

@Component({
  selector: 'app-import-setup-dialog',
  templateUrl: './import-setup-dialog.component.html',
  styleUrls: ['./import-setup-dialog.component.scss'],
  standalone: false,
})
export class ImportSetupDialogComponent extends AbstractDialog<ImportSetupDialogModel> {
  data = inject<AbstractDialogData>(MAT_DIALOG_DATA);
  protected readonly mdDialogRef =
    inject<
      MatDialogRef<ImportSetupDialogComponent, AbstractDialogResultData<ImportSetupDialogModel>>
    >(MatDialogRef);
  private readonly fb = inject(FormBuilder);

  formGroup = this.fb.group({
    deliveriesFrom: [new Date(new Date().getFullYear(), 0, 1), [Validators.required]],
    deliveriesUntil: [new Date(), [Validators.required]],
  });

  confirmFertilizerImport() {
    this.confirm({
      deliveriesFrom: this.formGroup.controls.deliveriesFrom.value,
      deliveriesUntil: this.formGroup.controls.deliveriesUntil.value,
    });
  }
}
